import { $cece } from "./index";

export const getCECE = async () => {
	const { data } = await $cece.get(
		"/api/Rotatia/ListaConsilierilorDinLocalitate?alegereId=19&scrutinTipId=18&raionId=115&localitateId=115",
	);

	return data;
};
